module.exports = __webpack_public_path__ + "static/media/icon-piece6-5.ad60e0ef.png";